import React, { useState, useEffect, useCallback } from 'react';
import './Testimonials.css';

const reviews = [
  {
    name: 'PK R',
    role: 'Parent – attending for over a year',
    date: 'May 2025',
    rating: 5,
    text: 'My daughter has been attending classes for more than a year now. Her teacher Mrs. Durga is an excellent teacher, very dedicated and humble. She gives importance even to minute details on areas of correction. I could see great improvement in my daughter. Now there are dedicated teachers who are doing a great job in moulding students with difficulties. Great going!',
    initial: 'PK',
    color: '#1a56db',
  },
  {
    name: 'Jayanthi Ramasamy',
    role: 'Parent – NIOS student',
    date: 'May 2025',
    rating: 5,
    text: 'One of the best teaching institutions for NIOS students. Highly recommended for any parent looking for quality coaching and genuine support.',
    initial: 'JR',
    color: '#1e8a45',
  },
  {
    name: 'Selvarevathy M',
    role: 'Parent – Learning Disability support',
    date: 'Sept 2024',
    rating: 5,
    text: 'I thank Durga ma\'am for moulding my child from LD to an average learner through excellent teaching. My daughter loves to learn because of Durga ma\'am. What a transformation!',
    initial: 'SM',
    color: '#7c3aed',
  },
  {
    name: 'Praveena Lokesh',
    role: 'Parent – coming here for 3 years',
    date: 'Sept 2024',
    rating: 5,
    text: 'I have been coming here for 3 years. I see a lot of improvement in my son\'s learning. Not only learning — behaviour issues have also been rectified by Durga madam. Truly a complete support centre.',
    initial: 'PL',
    color: '#0891b2',
  },
  {
    name: 'Dharani Vigneshwaran',
    role: 'Parent – special education',
    date: 'Oct 2024',
    rating: 4,
    text: 'Ma\'am and her team are doing a great job. They are so friendly and interactive!! The environment is very welcoming and the staff genuinely cares about each child.',
    initial: 'DV',
    color: '#e8681c',
  },
  {
    name: 'Balu P',
    role: 'Parent – special children',
    date: 'Sept 2024',
    rating: 5,
    text: 'Great place for special children. The care, patience and expertise shown by the team is outstanding. Every parent of a special child should know about this centre.',
    initial: 'BP',
    color: '#d93025',
  },
];

const StarRating = ({ count }) => (
  <div className="stars">
    {[1,2,3,4,5].map((i) => (
      <span key={i} className={`star ${i <= count ? 'star-filled' : 'star-empty'}`}>★</span>
    ))}
  </div>
);

export default function Testimonials() {
  const [active,  setActive]  = useState(0);
  const [paused,  setPaused]  = useState(false);

  const next = useCallback(() => setActive((p) => (p + 1) % reviews.length), []);
  const prev = () => setActive((p) => (p === 0 ? reviews.length - 1 : p - 1));

  useEffect(() => {
    if (paused) return;
    const id = setInterval(next, 5000);
    return () => clearInterval(id);
  }, [paused, next]);

  const r = reviews[active];

  return (
    <section className="testi-section reveal" id="testimonials">
      <div className="testi-wrapper">

        {/* Header */}
        <div className="testi-header">
          <span className="section-badge">Parent Reviews</span>
          <h2 className="section-title">What Parents Say About Us</h2>
          <p className="section-sub">
            Real experiences from parents who trusted Akshara with their child's learning journey.
            All reviews are verified on Google.
          </p>
          {/* Google badge */}
          <div className="google-badge">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Verified Google Reviews
          </div>
        </div>

        {/* Featured review */}
        <div
          className="testi-featured"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div className="testi-quote-mark">"</div>

          <div className="testi-body">
            <div className="testi-meta">
              <StarRating count={r.rating} />
              <span className="testi-date">{r.date}</span>
            </div>

            <p className="testi-text">{r.text}</p>

            <div className="testi-author">
              <div
                className="testi-avatar"
                style={{ background: `linear-gradient(135deg, ${r.color}, #0d1b4b)` }}
              >
                {r.initial}
              </div>
              <div>
                <p className="testi-name">{r.name}</p>
                <p className="testi-role">{r.role}</p>
              </div>
            </div>
          </div>

          <button className="testi-arrow testi-prev" onClick={prev} aria-label="Previous">‹</button>
          <button className="testi-arrow testi-next" onClick={next} aria-label="Next">›</button>
        </div>

        {/* Thumbnail cards */}
        {/* <div className="testi-thumbs">
          {reviews.map((rv, i) => (
            <div
              key={i}
              className={`testi-thumb ${i === active ? 'active' : ''}`}
              onClick={() => { setActive(i); setPaused(true); }}
            >
              <div
                className="thumb-avatar"
                style={{ background: `linear-gradient(135deg, ${rv.color}, #0d1b4b)` }}
              >
                {rv.initial}
              </div>
              <div className="thumb-info">
                <p className="thumb-name">{rv.name}</p>
                <div className="thumb-stars">
                  {[1,2,3,4,5].map((i) => (
                    <span key={i} style={{ color: i <= rv.rating ? '#f59e0b' : '#e5e7eb', fontSize: '11px' }}>★</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div> */}

        {/* Dots */}
        <div className="testi-dots">
          {reviews.map((_, i) => (
            <button
              key={i}
              className={`testi-dot ${i === active ? 'active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Review ${i + 1}`}
            />
          ))}
        </div>

        {/* Summary bar */}
        {/* <div className="testi-summary">
          <div className="summary-item">
            <span className="summary-val">★ 4.9</span>
            <span className="summary-label">Google Rating</span>
          </div>
          <div className="summary-divider" />
          <div className="summary-item">
            <span className="summary-val">6+</span>
            <span className="summary-label">Google Reviews</span>
          </div>
          <div className="summary-divider" />
          <div className="summary-item">
            <span className="summary-val">500+</span>
            <span className="summary-label">Students Helped</span>
          </div>
          <div className="summary-divider" />
          <div className="summary-item">
            <span className="summary-val">15+</span>
            <span className="summary-label">Years of Trust</span>
          </div>
        </div> */}

      </div>
    </section>
  );
}
